import React from 'react'
import PropTypes from 'prop-types'
import 'bpmn-js/dist/assets/diagram-js.css'
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css'
import './style.scss'

export const Bpmn = ({ id }) => {
  return (
    <div className="bpmnContainer modeler" id="js-drop-zone">
      <div id={`bpmn-${id}`} className="bpmn"></div>
    </div>
  )
}

Bpmn.displayName = 'Bpmn'

Bpmn.propTypes = {
  id: PropTypes.string.isRequired
}

Bpmn.defaultProps = {
  id: 0
}
